<template>
  <section class="dp-layout mr-page-layout">
    <section class="dp-right mr-module">
      <div class="page-header">
        <div>
          <div class="header-title-bar">
            <span class="header-icon-bar"></span>
            <h3>签到规则配置</h3>
          </div>
          <p class="page-desc">学校级签到宽限与开始前提醒规则</p>
        </div>
        <el-tag v-if="schoolName" type="success" size="medium" effect="plain" class="school-badge">
          <i class="el-icon-school"></i> {{ schoolName }}
        </el-tag>
        <span v-else-if="!schoolId" class="school-hint">请在顶部选择学校</span>
      </div>

      <div v-if="!schoolId" class="empty-tip">请在顶部选择学校后配置签到规则</div>

      <el-card v-else class="config-card" shadow="never" v-loading="loading">
        <el-form ref="configForm" :model="form" label-width="160px" style="max-width: 560px;" size="small">
          <el-form-item label="提前签到（分钟）">
            <el-input-number v-model="form.checkInAdvanceMinutes" :min="1" :max="120" :disabled="!schoolId" />
            <div class="form-tip">会议开始前允许签到的提前分钟数</div>
          </el-form-item>
          <el-form-item label="无人释放宽限（分钟）">
            <el-input-number v-model="form.noShowGraceMinutes" :min="1" :max="120" :disabled="!schoolId" />
            <div class="form-tip">会议开始后无人签到，超过宽限时间可释放时段</div>
          </el-form-item>
          <el-form-item label="开始前提醒（分钟）">
            <el-input-number v-model="form.notifyAdvanceMinutes" :min="1" :max="120" :disabled="!schoolId" />
            <div class="form-tip">通知类型为「开始前提醒」的会议，提前 N 分钟推送</div>
          </el-form-item>
          <el-form-item style="margin-top: 24px;">
            <el-button v-if="canSave" type="primary" icon="el-icon-check" :loading="saving"
              :disabled="!schoolId" @click="save">保存配置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </section>
  </section>
</template>

<script>
import axios from 'axios';
import { BaseApiUrl } from '../../api/base';
import { resolveActiveSchoolId } from '../../utils/deptCascaderProps';
import { getButtonList } from '../../utils/routeButtonList';

const apiBase = BaseApiUrl;

export default {
  name: 'MeetingRoomSchoolConfig',
  data() {
    return {
      loading: false,
      saving: false,
      buttonList: [],
      form: {
        checkInAdvanceMinutes: 15,
        noShowGraceMinutes: 15,
        notifyAdvanceMinutes: 15
      }
    };
  },
  computed: {
    schoolId() {
      return resolveActiveSchoolId(this);
    },
    schoolName() {
      return this.$store.state.activeSchoolName || '';
    },
    canSave() {
      return (this.buttonList || []).some(b => b.Func === 'saveSchoolConfig');
    }
  },
  watch: {
    schoolId(val, oldVal) {
      if (val === oldVal) return;
      if (val) this.loadConfig();
      else this.resetForm();
    }
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    if (this.schoolId) this.loadConfig();
  },
  methods: {
    resetForm() {
      this.form = {
        checkInAdvanceMinutes: 15,
        noShowGraceMinutes: 15,
        notifyAdvanceMinutes: 15
      };
    },
    loadConfig() {
      if (!this.schoolId) return;
      this.loading = true;
      axios.get(`${apiBase}/api/MeetingRoom/GetSchoolConfig`, {
        params: { schoolId: this.schoolId }
      }).then(res => {
        this.loading = false;
        if (res.data.success && res.data.response) {
          const c = res.data.response;
          this.form = {
            checkInAdvanceMinutes: c.CheckInAdvanceMinutes || 15,
            noShowGraceMinutes: c.NoShowGraceMinutes || 15,
            notifyAdvanceMinutes: c.NotifyAdvanceMinutes || 15
          };
        }
      }).catch(() => { this.loading = false; });
    },
    save() {
      if (!this.schoolId) return;
      this.saving = true;
      axios.post(`${apiBase}/api/MeetingRoom/SaveSchoolConfig`, {
        SchoolId: this.schoolId,
        CheckInAdvanceMinutes: this.form.checkInAdvanceMinutes,
        NoShowGraceMinutes: this.form.noShowGraceMinutes,
        NotifyAdvanceMinutes: this.form.notifyAdvanceMinutes
      }).then(res => {
        this.saving = false;
        if (res.data.success) {
          this.$message.success('配置已保存');
        } else {
          this.$message.error(res.data.msg || '保存失败');
        }
      }).catch(() => { this.saving = false; });
    }
  }
};
</script>
